import MetricsSideMenuContainer from "./container";
import MetricsSideMenu from "./component";
import { supported_item_metrics, supported_flyer_metrics } from "./component";
export {
  MetricsSideMenuContainer,
  MetricsSideMenu,
  supported_item_metrics,
  supported_flyer_metrics
};



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsSideMenu/index.ts